export const FLUID_BALANCE = {
  masterTableName: 'MC_FLUID_BALANCES',

  tableName: 'MC_FLUID_BALANCES',
  columnName: 'ID',
  columnValue: 0,

  title: 'Sıvı Dengesi Takibi',

  // Veritabanından gelen verileri eşleştirme
  rows: [
    { title: 'pdate', value: 'pdate', headerName: 'Tarih', type: 'date' },
    { title: 'io_type', value: 'io_type', headerName: 'Tip' },
    { title: 'f_name', value: 'f_name', headerName: 'Sıvı Adı' },
    { title: 'h0', value: 'h0' },
    { title: 'h1', value: 'h1' },
    { title: 'h2', value: 'h2' },
    { title: 'h3', value: 'h3' },
    { title: 'h4', value: 'h4' },
    { title: 'h5', value: 'h5' },
    { title: 'h6', value: 'h6' },
    { title: 'h7', value: 'h7' },
    { title: 'h8', value: 'h8' },
    { title: 'h9', value: 'h9' },
    { title: 'h10', value: 'h10' },
    { title: 'h11', value: 'h11' },
    { title: 'h12', value: 'h12' },
    { title: 'h13', value: 'h13' },
    { title: 'h14', value: 'h14' },
    { title: 'h15', value: 'h15' },
    { title: 'h16', value: 'h16' },
    { title: 'h17', value: 'h17' },
    { title: 'h18', value: 'h18' },
    { title: 'h19', value: 'h19' },
    { title: 'h20', value: 'h20' },
    { title: 'h21', value: 'h21' },
    { title: 'h22', value: 'h22' },
    { title: 'h23', value: 'h23' },
    { title: 'day_total_in', value: 'day_total_in', headerName: 'Toplam Giriş' },
    { title: 'day_total_out', value: 'day_total_out', headerName: 'Toplam Çıkış' },
    { title: 'day_balance', value: 'day_balance', headerName: 'Balans' },
  ],

  // DataGrid'de gösterilecek kolonlar
  fields: [
    { field: 'pdate', headerName: 'fluid-balance.date', flex: 1 },
    { field: 'io_type', headerName: 'fluid-balance.type', flex: 0.5 },
    { field: 'f_name', headerName: 'fluid-balance.fluidName', flex: 2 },
    { field: 'h0', headerName: '00', flex: 0.5 },
    { field: 'h1', headerName: '01', flex: 0.5 },
    { field: 'h2', headerName: '02', flex: 0.5 },
    { field: 'h3', headerName: '03', flex: 0.5 },
    { field: 'h4', headerName: '04', flex: 0.5 },
    { field: 'h5', headerName: '05', flex: 0.5 },
    { field: 'h6', headerName: '06', flex: 0.5 },
    { field: 'h7', headerName: '07', flex: 0.5 },
    { field: 'h8', headerName: '08', flex: 0.5 },
    { field: 'h9', headerName: '09', flex: 0.5 },
    { field: 'h10', headerName: '10', flex: 0.5 },
    { field: 'h11', headerName: '11', flex: 0.5 },
    { field: 'h12', headerName: '12', flex: 0.5 },
    { field: 'h13', headerName: '13', flex: 0.5 },
    { field: 'h14', headerName: '14', flex: 0.5 },
    { field: 'h15', headerName: '15', flex: 0.5 },
    { field: 'h16', headerName: '16', flex: 0.5 },
    { field: 'h17', headerName: '17', flex: 0.5 },
    { field: 'h18', headerName: '18', flex: 0.5 },
    { field: 'h19', headerName: '19', flex: 0.5 },
    { field: 'h20', headerName: '20', flex: 0.5 },
    { field: 'h21', headerName: '21', flex: 0.5 },
    { field: 'h22', headerName: '22', flex: 0.5 },
    { field: 'h23', headerName: '23', flex: 0.5 },
  ],

  // MCP konfigürasyonu henüz yok
  mcpConfig: {} as Record<string, { mcpId: number; field: string; scoreField: string }>,

  // useCardForm tarafından beklenen başlangıç form state'i
  formData: {
    ID: '',
    pdate: new Date(),
    io_type: '',
    f_id: 0,
    f_name: '',
    h0: 0,
    h1: 0,
    h2: 0,
    h3: 0,
    h4: 0,
    h5: 0,
    h6: 0,
    h7: 0,
    h8: 0,
    h9: 0,
    h10: 0,
    h11: 0,
    h12: 0,
    h13: 0,
    h14: 0,
    h15: 0,
    h16: 0,
    h17: 0,
    h18: 0,
    h19: 0,
    h20: 0,
    h21: 0,
    h22: 0,
    h23: 0,
    CTIME: new Date(),
    CUSER: '',
  },

  // Nabız ve tansiyon grafiklerini gizlemek için
  hideVitalCharts: true,

  // showSaveButton: true,
  // showNewFluidButton: true,
  // showDeleteButton: true,
  // showPrintButton: true,
};
